import { ChangeEvent, FC, SyntheticEvent, useContext, useState } from 'react';
import { useAppSelector } from '../../../hooks/store.hooks';

import { useSelector } from 'react-redux';

import '../styles/statusToggle.scss';

const ProductStatusToggle: FC<{ cell: any }> = ({ cell }) => {

  const { userToken } = useSelector((state: any) => state.rootReducer.auth);
  // const tableContext = useContext(TableContext);

  const handleCheckboxChange = (e: React.MouseEvent<HTMLInputElement>, cell: any) => {
    let updatedStatus = e.currentTarget.checked ? 'true' : 'false';
    // tableContext?.openConfirmPopup({
    //   mearchant_user_id: cell?.row?.values?.userDetails.id,
    //   token: userToken,
    //   sub_domain: window.location.host.split('.')[0],
    //   created_by: profileData?.id,
    //   toggleStatus: updatedStatus,
    //   cols: tableStateColumns,
    //   name: cell?.row?.values?.userDetails.name,
    //   userName: cell?.row?.values?.userDetails.username,
    // });
  };



  return (
    <div className="flex justify-end items-end">
      <div className="md:relative static flex items-center justify-center overflow-hidden max-sm:top-[11px] max-sm:right-10">
        <div className="flex">
        <label className="relative inline-flex items-center cursor-pointer switch">
              <input
                type="checkbox"
                className="sr-only peer"
                // defaultChecked={cell?.row?.values?.Status === 'ACTIVE'}
                // readOnly
                // checked={cell?.row?.values?.Status === 'ACTIVE'}
                // onClick={(e) => {
                //   handleChange(e, cell);
                // }}
                checked={cell?.row?.values?.status === true}
                onChange={(e: any) => handleCheckboxChange(e, cell)}
              />

              <div className="slider round peer-checked:bg-primary1 shadow-toggleShadow"></div>

            </label>
        </div>
      </div>
    </div>
  );
};

export default ProductStatusToggle;
